/* models/glyphs/center_rotatable */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    var xy_glyph_1 = require(153) /* ./xy_glyph */;
    var p = require(18) /* ../../core/properties */;
    var CenterRotatableView = /** @class */ (function (_super) {
        tslib_1.__extends(CenterRotatableView, _super);
        function CenterRotatableView() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        CenterRotatableView.__name__ = "CenterRotatableView";
        return CenterRotatableView;
    }(xy_glyph_1.XYGlyphView));
    exports.CenterRotatableView = CenterRotatableView;
    var CenterRotatable = /** @class */ (function (_super) {
        tslib_1.__extends(CenterRotatable, _super);
        function CenterRotatable(attrs) {
            return _super.call(this, attrs) || this;
        }
        CenterRotatable.initClass = function () {
            this.mixins(['line', 'fill']);
            this.define({
                angle: [p.AngleSpec, 0],
                width: [p.DistanceSpec],
                height: [p.DistanceSpec],
            });
        };
        CenterRotatable.__name__ = "CenterRotatable";
        return CenterRotatable;
    }(xy_glyph_1.XYGlyph));
    exports.CenterRotatable = CenterRotatable;
    CenterRotatable.initClass();
}
